// Progress helpers shared by the student and parent dashboards.
// Everything here is derived from data the app already stores:
//   - child.lessonsComplete.chess / streak / totalXP (Firestore child doc,
//     carried in the childSession / parentPreview snapshot)
//   - the per-day session state in localStorage (utils/sessionSchedule.js)
// Nothing is invented: if a value isn't recorded, the dashboards say so.
import { LESSON_1 } from '../data/chessLesson1';
import { LESSON_2 } from '../data/chessLesson2';
import { LESSON_3 } from '../data/chessLesson3';
import { LESSON_4 } from '../data/chessLesson4';
import { LESSON_5 } from '../data/chessLesson5';

export const CHESS_TOTAL_LESSONS = 24;

// Lessons 1–5 are the ones built so far (MainSession plays these five).
export const CHESS_LESSONS = [LESSON_1, LESSON_2, LESSON_3, LESSON_4, LESSON_5].map((l, i) => {
  const [name, detail] = l.title.split(' — ');
  return { n: i + 1, name, detail: detail || 'Beginner Module', title: l.title };
});

export function chessDone(child) {
  return Math.max(0, Math.min(child?.lessonsComplete?.chess || 0, CHESS_TOTAL_LESSONS));
}

export function getAchievements(child) {
  const done = chessDone(child);
  const streak = child?.streak || 0;
  return [
    { icon: '🗺️', name: 'Board Boss',   desc: 'Finished Lesson 1', tint: 'var(--t-blue)',    earned: done >= 1 },
    { icon: '🔤', name: 'Letter Pro',   desc: 'Finished Lesson 2', tint: 'var(--yellow-bg)', earned: done >= 2 },
    { icon: '🏰', name: 'Line Master',  desc: 'Finished Lesson 3', tint: 'var(--t-green)',   earned: done >= 3 },
    { icon: '👑', name: 'Royal Mover',  desc: 'Finished Lesson 4', tint: 'var(--t-lav)',     earned: done >= 4 },
    { icon: '🐴', name: 'Knight Rider', desc: 'Finished Lesson 5', tint: 'var(--t-peach)',   earned: done >= 5 },
    { icon: '🔥', name: 'On a Roll',    desc: '3-day streak',      tint: 'var(--t-peach)',   earned: streak >= 3 },
  ];
}

// Daily session records saved on this device (sessionSchedule.saveSessionState)
// for the last `days` days, oldest first.
export function getRecentSessions(childId, days = 7) {
  const out = [];
  const today = new Date();
  for (let i = days - 1; i >= 0; i--) {
    const d = new Date(today);
    d.setDate(today.getDate() - i);
    const date = d.toISOString().slice(0, 10);
    let state = null;
    try { state = JSON.parse(localStorage.getItem(`session_${childId}_${date}`) || 'null'); } catch { state = null; }
    const minutes = state?.completedAt && state?.startedAt
      ? Math.max(1, Math.min(180, Math.round((state.completedAt - state.startedAt) / 60000)))
      : 0;
    out.push({ date, day: d.toLocaleDateString('en-GB', { weekday: 'short' }), state, minutes });
  }
  return out;
}

export function formatMinutes(m) {
  if (m < 60) return `${m}m`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
}
